exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-bar[data-v-0fe84f58] {\n  text-align: left;\n  padding: 10px;\n}\n.filter-bar--customer[data-v-0fe84f58] {\n  max-width: 400px;\n}\n.user-picker[data-v-0fe84f58] {\n  width: 280px;\n}\n.orders[data-v-0fe84f58] {\n  color: #464646;\n}\n.price[data-v-0fe84f58] {\n  font-size: 1.1em;\n  font-weight: bold;\n}\n.thumbnail[data-v-0fe84f58] {\n  width: 60px;\n  height: 60px;\n  -o-object-fit: cover;\n     object-fit: cover;\n  cursor: pointer;\n}\n", ""]);

// exports
